import {Application} from "../../lib/Application.js";
import {CustomerRepository} from "../CustomerRepository.js";
import {ClickUpCustomerRepository} from "../clickup/ClickUpCustomerRepository.js";
import {ClickUpClient} from "../../lib/ClickUp/ClickUpClient.js";
import {SettingsRepository} from "../../app/SettingsRepository.js";

/** @param {Application} app **/
export function initCrm(app) {
    app.bindSingleton(CustomerRepository, () => {
        let settingsRepo = app.resolve(SettingsRepository);
        let settings = settingsRepo.get();
        return new ClickUpCustomerRepository(app.resolve(ClickUpClient), settings.customerSource);
    });
}